import { render, staticRenderFns } from "./STableDetailReportSaleComp.vue?vue&type=template&id=e4c295fe&"
import script from "./STableDetailReportSaleComp.vue?vue&type=script&lang=js&"
export * from "./STableDetailReportSaleComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports